import { Route, Routes } from "react-router-dom";
import BudgetVersion from "./budgetVersion";

const BudgetsPages = (props: any) => (
  <Routes>
    <Route path="" element={<BudgetVersion {...props} />} />
    <Route path="/:budgetId/versions/:version" element={<BudgetVersion {...props} />} />
  </Routes>
);

export default BudgetsPages;
